const TOUR_CLUSTER_MAX_ZOOM = 13

function initTourMap() {
	const $mapContainer = $('#googlemap')
	if (!$mapContainer.length) return

	const $tour = $('.tour')
	const $list = $tour.find('.list')
	if (!$list.length) return

	const options = {
		center: { lat: 51.3397, lng: 12.3731 },
		zoom: 14,
		styles: typeof tourstyles !== 'undefined' ? tourstyles : null,
		draggable: true,
		scrollwheel: false,
		scaleControl: true,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false
	}

	map = new google.maps.Map($mapContainer[0], options)

	if (!defaultIcon) {
		defaultIcon = createCircleIcon(20, '#3b00d2', '#ffffff', 3)
	}
	if (!activeIcon) {
		activeIcon = createCircleIcon(26, '#3b00d2', '#ffffff', 3)
	}

	markers.length = 0
	activeId = null

	$list.find('.call').each(function () {
		const $item = $(this)
		const latlong = $item.data('latlong')
		const id = $item.data('id')
		if (!latlong || !id) return

		const parts = latlong.toString().split(',')
		const lat = parseFloat(parts[0])
		const lng = parseFloat(parts[1])
		if (isNaN(lat) || isNaN(lng)) return

		const dateText = $item.find('.date').text()
		const text = $item.find('.text').text()

		const marker = new google.maps.Marker({
			position: { lat: lat, lng: lng },
			map: map,
			title: dateText,
			icon: defaultIcon
		})

		const infoWindow = new google.maps.InfoWindow({
			content: '<strong>' + dateText + '</strong><br>' + text
		})

		const entry = {
			id: id,
			marker: marker,
			infoWindow: infoWindow,
			$item: $item,
			year: null,
			origLat: lat,
			origLng: lng
		}

		markers.push(entry)

		marker.addListener('mouseover', function () {
			infoWindow.open(map, marker)
			setActiveById(id, true)
		})

		marker.addListener('mouseout', function () {
			infoWindow.close()
		})

		marker.addListener('click', function () {
			scrollListToItem($item)
		})
	})

	if (typeof window.initTourCluster === 'function') {
		window.initTourCluster(map, markers, { maxZoom: TOUR_CLUSTER_MAX_ZOOM })
	}

	map.addListener('zoom_changed', function () {
		if (typeof window.renderTourCluster === 'function') window.renderTourCluster()
	})

	$list.off('mouseenter.tourHover').on('mouseenter.tourHover', '.call', function () {
		const id = $(this).data('id')
		setActiveById(id, false)
	})

	if (markers.length) {
		adjustMapBounds(markers)
	}
}
